// extracted by mini-css-extract-plugin
module.exports = {"container":"filters-menu_container__3dA9I","actionTab":"filters-menu_actionTab__1N8yf","active":"filters-menu_active__3Uz9x"};